import React from 'react';

import { Row, Col } from 'antd';

import styled from 'styled-components';

import { ContactDetailsContainer } from '@components/ContactDetails/CommonStyles/ContactDetailsContainer';

import { useUserPermission } from '@contexts/UserContext';

import ContactDetailsTasks from '../CommonComponents/ContactDetailsTasks';
import ModelDetailsCustomPropertiesAndNotesTabs from './CommonComponents/ModelDetailsCustomPropertiesAndNotesTabs';
import ContactDetailsStatement from '@components/ContactDetails/CommonComponents/ContactDetailsStatement';

import ModelDetailsHeaderDrawerAccounting from '@components/ContactDetails/ContactDetailsHeader/ModelDetailsHeaderDrawerAccounting';
import ContactDetailsDocuments from '@components/ContactDetailsDocuments/ContactDetailsDocuments';
import ModelAgenciesCard from '@components/ModelAgencies/ModelAgenciesCard';
import SystemMessage from '@components/Utils/SystemMessage';

const CardLine = styled.div`
    margin-bottom: 12px;
    box-sizing: border-box;
`;

const ModelDetailsAccountingContent = ({ currentModel, billingInfos, isFullPage }) => {
    const accessAccounting = useUserPermission('AccessAccounting');

    if (!accessAccounting) {
        return <SystemMessage type="not-allowed" />;
    }

    return (
        <ContactDetailsContainer className="model-drawer-accounting">
            <ModelDetailsHeaderDrawerAccounting
                currentContact={currentModel}
                billingInfos={billingInfos}
                drawerMode
                onOpenModelAgencies={() => {}}
                onOpenStatements={() => {}}
            />
            {currentModel && currentModel.Approved && billingInfos && billingInfos.length > 0 && (
                <ContactDetailsStatement
                    contactID={currentModel.ID}
                    contactType={currentModel.ContactType}
                    contactSubType={currentModel.SubType}
                />
            )}
            {isFullPage ? (
                <Row gutter={10}>
                    <Col span={14}>
                        <ModelAgenciesCard
                            contactID={currentModel.ID}
                            represented={currentModel.Represented}
                            drawerMode
                        />
                    </Col>
                    <Col span={10}>
                        <ContactDetailsDocuments currentContact={currentModel} readOnly />
                    </Col>
                </Row>
            ) : (
                <CardLine>
                    <ModelAgenciesCard contactID={currentModel.ID} represented={currentModel.Represented} drawerMode />
                </CardLine>
            )}

            {isFullPage ? (
                <Row gutter={10} style={{ marginTop: '12px' }}>
                    <Col span={14}>
                        <ModelDetailsCustomPropertiesAndNotesTabs currentContact={currentModel} drawerMode />
                    </Col>
                    <Col span={10}>
                        <ContactDetailsTasks currentContact={currentModel} />
                    </Col>
                </Row>
            ) : (
                <>
                    <CardLine>
                        <ContactDetailsTasks currentContact={currentModel} />
                    </CardLine>
                    <CardLine>
                        <ModelDetailsCustomPropertiesAndNotesTabs currentContact={currentModel} drawerMode />
                    </CardLine>
                </>
            )}
            {!isFullPage && (
                <CardLine>
                    <ContactDetailsDocuments currentContact={currentModel} readOnly />
                </CardLine>
            )}
        </ContactDetailsContainer>
    );
};

export default ModelDetailsAccountingContent;
